import React, { useEffect, useState } from 'react'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import TriggerDescriptionInsta from '../TriggerDescriptionInsta'
import { toast } from 'react-toastify'
import { getValidPreviousIntentId } from '../../../../utils/functions/getValidPreviousIntentId'
import { updateInstagramIntent } from '../../../../utils/functions/updateInstagramIntent'
// import { updateWhatsAppIntent } from '../../../../utils/functions/updateWhatsAppIntent'

interface IProps {
  intent: any
  inputJson: any[]
  setInputJson: React.Dispatch<React.SetStateAction<any[]>>
  closeModal: () => void
  data: any
}

const Text: React.FC<IProps> = ({ intent, inputJson, setInputJson, closeModal, data }) => {
  const intentIndex = inputJson.findIndex((item) => item.id === intent.id)
  const [isSaving, setIsSaving] = useState(false)

  const handleChange = (e: any) => {
    const name = e.target.name
    const value = e.target.value
    const newInputJson = [...inputJson]

    if (name === 'message' && value.length > 0) {
      newInputJson[intentIndex] = {
        ...intent,
        message: {
          ...intent.message,
          text: value
        }
      }
    }

    if (name === 'trigger' && !!parseInt(value)) {
      newInputJson[intentIndex] = {
        ...intent,
        trigger: parseInt(value)
      }
    }

    if (name === 'intentDescription') {
      newInputJson[intentIndex] = {
        ...intent,
        intentDescription: value
      }
    }

    setInputJson(newInputJson)
  }

  const handleSave = async () => {
    const token = localStorage.getItem('auth-token')
    const instagramIDString = data?.instagramIDString
    const previousIntentId = getValidPreviousIntentId(
      intentIndex,
      inputJson,
      data?.WhatsAppInput || []
    )
    setIsSaving(true)
    await updateInstagramIntent({
      token,
      instagramIDString,
      intent,
      intentJson: inputJson[intentIndex],
      previousIntentId,
      onSuccess: closeModal
    })
  }

  useEffect(() => {
    console.log({ inputJson })
    console.log({ intent })
  }, [inputJson])

  let titleText
  if (intent?.start) {
    titleText = 'Welcome Intent'
  } else if (intent?.end) {
    titleText = 'End Intent'
  } else {
    titleText = 'Text'
  }

  return (
    <>
      <h5 className='card-title h4 mb-5'>{titleText}</h5>

      <InputGroup className='my-3'>
        <InputGroup.Text>Intent Description</InputGroup.Text>
        <Form.Control
          id={`desc-${intent.id}`}
          type='text'
          name='intentDescription'
          defaultValue={intent?.intentDescription}
          onBlur={handleChange}
        />
      </InputGroup>

      {!!intent.message?.text && (
        <InputGroup className='my-3'>
          <InputGroup.Text>Message</InputGroup.Text>
          <Form.Control
            id={`message-${intent.id}`}
            as='textarea'
            name='message'
            defaultValue={intent.message.text}
            onBlur={handleChange}
          />
        </InputGroup>
      )}

      {!!intent.trigger && (
        <InputGroup className='my-3'>
          <InputGroup.Text>Trigger</InputGroup.Text>
          <Form.Select
            id={`trigger-${intent.id}`}
            name='trigger'
            defaultValue={intent.trigger}
            onChange={handleChange}
          >
            <TriggerDescriptionInsta inputJson={inputJson} />
          </Form.Select>
        </InputGroup>
      )}

      <div className='d-flex ms-auto mt-auto'>
        <button className='btn btn-secondary me-4' onClick={closeModal}>
          <i className='bi bi-eye-fill' /> Preview
        </button>
        <button className='btn btn-primary' onClick={handleSave}>
          <i className='bi bi-save' /> {isSaving ? 'Saving...' : 'Save'}
        </button>
      </div>
    </>
  )
}

export default Text
